import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {
  public transform(value: string): string {
    if (!value) return '';
    ////return value.replace(/<\/?(div|p)[^>]*>/gi, '');

    const parser = new DOMParser();
    const doc = parser.parseFromString(value, 'text/html');
    return doc.querySelector("div, p")?.textContent || value;
  }
}
